/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { shapes } from '@greenville/framework';
import { inject, observer } from 'mobx-react';

import UnauthorizedBody from '../error/UnauthorizedBody';
import UsersPermissions from './models/UsersPermissions';
import { permissions } from '../../common/constants';

const ValidatePermissions = ({ children, givenPermissions, userPermissions, permissionsStatus }) => {
  if (!permissionsStatus.isPending && !permissionsStatus.isError) {
    const permission = userPermissions.selectedPermissions || [];
    if (permission && permission.length > 0) {
      if (permission.includes(givenPermissions)) {
        return children;
      } else {
        return <UnauthorizedBody />;
      }
    } else if (permission.includes(permissions.NO_ACCESS_RESTRICTED)) {
      return children;
    }
  }
  return null;
};

ValidatePermissions.propTypes = {
  children: PropTypes.array.isRequired,
  givenPermissions: PropTypes.string.isRequired,
  userPermissions: shapes.modelOf(UsersPermissions).isRequired,
  permissionsStatus: shapes.state.isRequired,
  showDashboardEnabled: PropTypes.bool
};

ValidatePermissions.defaultProps = {
  showDashboardEnabled: true
};

export default inject('userPermissions', 'permissionsStatus')(observer(ValidatePermissions));
